import axios from "axios";
import { APP_CONFIG } from "../configs/config";

const API_ERP_URL = APP_CONFIG.API_ERP_URL || "http://localhost:2516/api/v1";

class ArticleService {
  /**
   * Fetch published articles by category
   * @param {string} category - Article category filter (optional)
   * @param {number} page - Page number (default: 1)
   * @param {number} limit - Items per page (default: 100)
   * @returns {Promise<Object>} Response with articles array and pagination info
   */
  async getArticles(category = null, page = 1, limit = 100) {
    try {
      const params = {
        page,
        limit,
      };

      if (category) {
        params.category = category;
      }

      const response = await axios.get(`${API_ERP_URL}/articles-public`, {
        params,
        headers: {
          "Content-Type": "application/json",
        },
      });

      return {
        success: true,
        data: response.data.articles || [],
        pagination: response.data.pagination || {},
        filters: response.data.filters || {},
      };
    } catch (error) {
      console.error("Error fetching articles:", error);
      return {
        success: false,
        error:
          error.response?.data?.detail ||
          error.message ||
          "Failed to fetch articles",
        data: [],
      };
    }
  }

  /**
   * Fetch a single article by slug
   * @param {string} slug - Article slug
   * @param {string} language - Language code (default: 'en')
   * @returns {Promise<Object>} Response with article data
   */
  async getArticleBySlug(slug, language = "en") {
    try {
      const response = await axios.get(
        `${API_ERP_URL}/articles-public/${slug}`,
        {
          params: { language },
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error("Error fetching article by slug:", error);
      return {
        success: false,
        error:
          error.response?.data?.detail ||
          error.message ||
          "Failed to fetch article",
        data: null,
      };
    }
  }
}

const articleService = new ArticleService();
export default articleService;
